// src/components/Footer.js
import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="custom-footer">
      <p>© 2025. Centro Analítico de Patología. Todos los derechos reservados</p>
    </footer>
  );
};

export default Footer;
